"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _useLocalStorageSVG = _interopRequireDefault(require("../../shared/hooks/useLocalStorageSVG"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/*
Fetches SVG symbol from CDN and places inline on page
Source for SVG symbol is "icons.svg"
Which is uploaded to the stipple/assets directory

Fetching instead of placing inline to leverage browser caching
And to reduce bundle size, since icons are one of the largest assets
for this package

*/
function IconSymbol() {
  var version = 12;
  (0, _useLocalStorageSVG["default"])({
    url: "https://screentone.djnews.tools/assets/icons." + version + ".svg",
    id: 'st-icons',
    version: version
  });
  return null;
}

var _default = IconSymbol;
exports["default"] = _default;